/* eslint-disable @typescript-eslint/no-explicit-any */
import { SplashScreen } from '@capacitor/splash-screen';

/**
 * It hides the Splashscreen when the {@link ionViewDidEnter} hooks is called on the decorated page component.
 * Apply this decorator only to pages that could be directly reached when opening the app.
 *
 * The behavior could be included in the {@link IonicPageComponent} class. However, it
 * would be applied to all the components, and we want to avoid that since we need this only
 * when the application starts.
 */
export function AfterSplashScreen(): ClassDecorator {
  return function (target: any) {
    const originalMethod = target.prototype.ionViewDidEnter;

    target.prototype.ionViewDidEnter = function (...args: any) {
      SplashScreen.hide();
      originalMethod?.apply(this, args);
    };
  };
}
